import getHistorySuggestionsInternal from './history-get.js';
import comparable from '../../../Assets/helpers/string/comparable.js';
import setHistorySuggestionsInternal from './history-set.js';

export default function deleteHistorySuggestion(value) {
  const previousSuggestions = getHistorySuggestionsInternal();
  const comparableValue = comparable(value);
  const suggestions = previousSuggestions.filter((v) => comparable(v) !== comparableValue);
  setHistorySuggestionsInternal(suggestions);
  return suggestions.length !== previousSuggestions.length;
}
